'use client';
import React, { useState } from 'react';
import { User, MapPin, Clock, Package, Image, CreditCard } from 'lucide-react';
import ProfileTab from './ProfileTab';
import LocationTab from './LocationTab';
import OpeningHoursTab from './OpeningHoursTab';
import ServicesTab from './ServicesTab';
import GalleryTab from './GalleryTab';
import SubscriptionTab from './SubscriptionTab';

const tabs = [
  { id: 'tab-profile', label: 'Profile', icon: User, component: ProfileTab },
  { id: 'tab-location', label: 'Location', icon: MapPin, component: LocationTab },
  { id: 'tab-hours', label: 'Opening Hours', icon: Clock, component: OpeningHoursTab },
  { id: 'tab-services', label: 'Services', icon: Package, component: ServicesTab },
  { id: 'tab-gallery', label: 'Gallery', icon: Image, component: GalleryTab },
  { id: 'tab-subscription', label: 'Subscription', icon: CreditCard, component: SubscriptionTab },
];

export default function ListingManagementTabs() {
  const [activeTab, setActiveTab] = useState('tab-profile');

  const ActiveComponent = tabs?.find((t) => t?.id === activeTab)?.component || ProfileTab;

  return (
    <div>
      {/* Tab nav */}
      <div className="flex overflow-x-auto border-b border-border mb-6 gap-0">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => setActiveTab(tab?.id)}
            className={`flex items-center gap-2 px-4 py-3 text-sm font-semibold whitespace-nowrap border-b-2 transition-colors ${
              activeTab === tab?.id
                ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-border'
            }`}
          >
            <tab.icon size={15} />
            {tab?.label}
          </button>
        ))}
      </div>
      <ActiveComponent />
    </div>
  );
}